export default __webpack_public_path__ + "static/contour-pattern-31b9121b55c7a157c438084d7a7bab57.svg";